<template>
  <article>
    <activity-stage>
      <template slot="instructions">
        <slot name="instructions"></slot>
      </template>
      <article slot="content" id="math-sentences-content-container">
        <img
          alt="Round image"
          :src="currentRound?.teacherImage?.image?.src"
          v-if="currentRound?.teacherImage?.image"
        />
        <div id="steps">
          <text-display-list element="div" id="input" text-size="medium">
            <blinking-cursor-text
              v-for="(step, stepIndex) in currentRound?.steps"
              :key="`step${stepIndex}`"
              :text="step.answer"
              :text-step="stepIndex"
            ></blinking-cursor-text>
          </text-display-list>
        </div>
      </article>
    </activity-stage>
    <slot name="keyboard"></slot>
  </article>
</template>

<script>
import { TweenMax, TimelineLite } from 'gsap';

import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import ActivityManager from 'mixins/ActivityManager';

import ActivityStage from 'components/activity/ActivityStage.vue';
import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';
import TextDisplayList from 'components/text-displays/TextDisplayList.vue';

export default {
  mixins: [AssetLoader, TypingActivityHelper, ActivityManager, ErrorLogger],
  components: {
    ActivityStage,
    BlinkingCursorText,
    TextDisplayList
  },
  data() {
    return {
      activityName: 'Math Sentences'
    };
  },

  methods: {
    async loadActivity() {
      this.createRounds();
      await this.loadImages();
    },

    async loadImages() {
      this.rounds?.forEach(({ teacherImage }) => {
        this.queueImage(teacherImage.image);
      });

      return this.downloadImages();
    },

    getKeyboardConfig() {
      const { keyboardType, roofs } = this.activityData.keyboard;
      return {
        keyboardType,
        hideNumberRow: false,
        roofs
      };
    },

    startActivity() {
      this.setRound();

      this.$nextTick(this.setActivityContainerHeight);
    },

    setRound() {
      this.setupNewRound();
      this.enableKeyboard();
      this.errorLoggerStart();
      this.$nextTick(() => {
        TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
      });
    },

    handleCorrectKey(attempt) {
      this.incrementTypingIndex();
      this.sndType();

      this.captureKeyboardAttemptSegment(attempt, this.isEndOfCurrentSentence);

      if (this.isEndOfCurrentSentence) {
        this.sndBell();
        this.setCurrentStep();
      }

      if (this.isEndOfRound) {
        this.handleRoundEnd();
      }
    },

    handleRoundEnd() {
      const t = new TimelineLite();

      t.delay(0.8).call(() => {
        if (this.isLastRound) {
          TweenMax.delayedCall(0.8, this.completeActivity);
        } else {
          t.delay(1)
            .to('.activity-stage', 0.8, { opacity: 0 })
            .call(this.setRound);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 32%;
  float: left;
}

#steps {
  width: 62%;
  margin: 0px 1% 8% 1%;
  float: right;

  div {
    margin: 0px auto 5% auto;
  }

  ul,
  p {
    margin: 0;
    padding: 0;
  }
}

.chrome-os,
.tablet {
  #math-sentences-content-container {
    display: flex;

    img {
      float: none;
      height: auto;
      width: 250px;
    }

    #steps {
      float: none;
    }
  }
}
</style>
